import React from 'react';
import { Calendar, MapPin, DollarSign, CreditCard } from 'lucide-react';
import { formatPaymentMethod } from '@/utils/bookingUtils';
import DateTimeDisplay from '../../../components/booking/DateTimeDisplay';

export default function PaymentDetailsPanel({ result, location, statusColor }) {
  return (
    <div className="bg-gray-50 rounded-lg p-6 mb-6 space-y-4">
      <h3 className="font-semibold text-lg mb-3">Payment Details</h3>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <p className="text-sm text-gray-500">Transaction ID</p>
          <p className="font-mono text-sm">{result.transaction_id || 'N/A'}</p>
        </div>

        <div>
          <p className="text-sm text-gray-500">Status</p>
          <p className={`font-semibold ${statusColor}`}>
            {result.payment_status?.toUpperCase()}
          </p>
        </div>
      </div>

      <div className="border-t pt-4 mt-4">
        <div className="flex items-start gap-3 mb-3">
          <Calendar className="w-5 h-5 text-gray-400 mt-1" />
          <div>
            <p className="text-sm text-gray-500">Booking Date & Time</p>
            <DateTimeDisplay
              date={result.booking_date}
              timeSlot={result.time_slot}
              duration={result.duration}
              className="mt-1"
              testId="payment-result"
            />
          </div>
        </div>

        {location && (
          <div className="flex items-start gap-3 mb-3">
            <MapPin className="w-5 h-5 text-gray-400 mt-1" />
            <div>
              <p className="text-sm text-gray-500">Location</p>
              <p className="font-semibold">{location.name}</p>
              <p className="text-sm text-gray-600">{location.address}</p>
            </div>
          </div>
        )}

        <div className="flex items-start gap-3 mb-3">
          <DollarSign className="w-5 h-5 text-gray-400 mt-1" />
          <div>
            <p className="text-sm text-gray-500">Amount Paid</p>
            <p className="font-semibold text-lg">BND ${result.amount?.toFixed(2)}</p>
          </div>
        </div>

        <div className="flex items-start gap-3">
          <CreditCard className="w-5 h-5 text-gray-400 mt-1" />
          <div>
            <p className="text-sm text-gray-500">Payment Method</p>
            <p className="font-semibold" data-testid="payment-method-label">
              {formatPaymentMethod(result.payment_method || 'pocket_pay')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
